module.exports = __webpack_public_path__ + "static/media/loaderAppAlert.0c23dde9.wav";